<template>
  <div class="main">
    <!-- <w-title-bar :title="title" textColor="#000000" :show="show" :translateX="translateX"></w-title-bar> -->
    <div class="top_container">
      <div v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div class="swiper-slide" :key="banner" v-for="banner in skuPics">
            <div class="swiper-zoom-container">
              <img height="220px" :src="banner" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <el-card class="content-position">
      <div class="clearfix header">
        <img class="my_head_background" src="static/product_head.png" />
        <img class="my_head" src="static/suggest.png" />
        <span style="font-family:PingFang">{{groupName}}</span>
      </div>
      <div class="hint">{{hint}}</div>
      <el-form
        style="margin-top:15px"
        :model="labelPosition"
        label-width="0px"
        v-for="value in app"
        :key="value"
      >
        <el-form-item>
            <div style="display: inline-block;height:1rem;width:1rem"><img class="left_img" :src="value.appSrc" /></div>
            <div class="right_text">{{value.detail}}</div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import wTitleBar from "@/components/w-titleBar";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "show",
  components: {
    wTitleBar,
  },
  data() {
    return {
      title: "广告页面",
      show: false,
      translateX: 0,
      swiperOption: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      skuPics: ["/static/success_top.png", "/static/success_top.png"],
      groupName: "更多建议",
      labelPosition: "left",
      hint:
        "您购买的商品，还可以通过一下App进行鉴真溯源，如已安装，点击图标即可使用",
      app: [
        {
          appSrc: "/static/jd.png",
          detail: "进入京东商城，使用扫一扫功能，即可完成鉴真溯源",
        },
        {
          appSrc: "/static/wx.png",
          detail: "查找到‘真品无双’小程序，即可完成鉴真溯源",
        },
        {
          appSrc: "/static/yl.png",
          detail:
            "进入云闪付，使用‘NFC防伪’小程序，即可完成鉴真溯源，更多的红包等着您...",
        },
        // {
        //   appSrc: "/static/zfb.png",
        //   detail: "进入支付宝，使用‘NFC防伪’小程序，即可完成鉴真溯源",
        // },
        {
          appSrc: "/static/al.png",
          detail: "下载安装真品无双app，即可完成鉴真溯源",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style>
.main {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: scroll;
  background: #f6f6f6;
}
.top_container {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 15px;
  transform: translateY(-10px);
}
.content-position {
  margin: 0 15px 10px 10px;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.my_head {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.hint {
  font-size: 15px;
  font-weight: 700;
}
.left_img {
  height:3rem;
  width:3rem;
  vertical-align: middle;
}
.right_text {
  line-height: 25px;
  font-size: 15px;
  width: 75%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/show/show.vue